import { Badge } from '@/components/ui/badge'
import { buttonVariants } from '@/components/ui/button'
import { Card, CardContent, CardFooter, CardHeader } from '@/components/ui/card'
import { cn } from '@/lib/tailwind.utils'
import type { ComingUpFeatureItem } from '../types'
import { ArrowRight } from 'lucide-react'

export const ComingUpFeaturesCard = ({ item }: { item: ComingUpFeatureItem }) => {
  const { title, description, href } = item
  const hasAction = href.trim() != ''

  const card = (
    <Card className="flex h-full flex-col transition-colors hover:bg-neutral border dark:hover:border-neutral-100">
      <CardHeader className="pb-2">
        <div className="flex items-center justify-between">
          <Badge
            size={'xs'}
            className="bg-rexTeal-200 text-rexBlue-900 hover:bg-rexTeal-100 text-xs font-semibold uppercase"
          >
            New feature
          </Badge>
        </div>
        <p className="line-clamp-2 text-sm font-semibold leading-5 text-foreground">{title}</p>
      </CardHeader>

      <CardContent className="flex-1 pb-2">
        <p className="line-clamp-3 text-xs leading-relaxed text-muted-foreground">{description}</p>
      </CardContent>

      <CardFooter className="mt-auto justify-end pt-0">
        {hasAction && (
          <span
            className={cn(
              buttonVariants({ variant: 'ghost', size: 'sm' }),
              'pointer-events-none shrink-0 text-primary',
            )}
          >
            Share your thoughts
            <ArrowRight size={14} className="transition-transform group-hover:translate-x-0.5" />
          </span>
        )}
      </CardFooter>
    </Card>
  )

  return hasAction ? (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      aria-label={`${title} (opens in a new tab)`}
      className="group block h-full"
    >
      {card}
    </a>
  ) : (
    card
  )
}
